import type { Validity } from 'types/common/validationTypes';
import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type BookingHotelsState = {
  fetching: FetchingStatus | null;
  validity: Validity | null;
  value: BookingDetails['hotels'] | null;
};

const initialState: BookingHotelsState = {
  fetching: null,
  validity: null,
  value: null,
};

function setFetchingFunction(state: BookingHotelsState, action: PayloadAction<BookingHotelsState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setValidityFunction(state: BookingHotelsState, action: PayloadAction<BookingHotelsState['validity']>) {
  return {
    ...state,
    validity: action.payload,
  };
}

function setBookingHotelsFunction(state: BookingHotelsState, action: PayloadAction<BookingHotelsState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingHotels',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setValidity: setValidityFunction,
    setBookingHotels: setBookingHotelsFunction,
    resetState: resetStateFunction,
  },
});

export const { setFetching, setValidity, setBookingHotels, resetState } = slice.actions;
export default slice.reducer;
